// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_DETAIL_VARIANTS_HEADING = "Vyber si variant";
export const STROLLER_DETAIL_VARIANT_SHOW_OPTIONS = "Zobrazi\u0165 mo\u017enosti";
export const STROLLER_DETAIL_VARIANT_UNAVAILABLE = "Nedostupn\u00e9";
